"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LongTextGeneralHandler", {
    enumerable: true,
    get: function() {
        return LongTextGeneralHandler;
    }
});
const _catchError = require("src/helpers/catchError");
const _constants = require("src/constants");
const _nocodbsdk = require("nocodb-sdk");
const _generic = require("~/db/field-handler/handlers/generic");
let LongTextGeneralHandler = class LongTextGeneralHandler extends _generic.GenericFieldHandler {
    async parseUserInput(params) {
        var _ref;
        let value = params.value;
        if ((0, _nocodbsdk.isAIPromptCol)(params.column) && (0, _nocodbsdk.ncIsObject)(value)) {
            var _value_value;
            value = (_value_value = value.value) != null ? _value_value : '';
        }
        value = (_ref = value == null ? void 0 : value.toString()) != null ? _ref : '';
        // if (typeof params.value !== 'string') {
        //   NcError.invalidValueForField({
        //     value: params.value,
        //     column: params.column.title,
        //     type: params.column.uidt,
        //   });
        // }
        // if (
        //   Number(params.column.dtxp) > 0 &&
        //   params.value.length > Number(params.column.dtxp)
        // ) {
        //   NcError.invalidValueForField({
        //     value: params.value,
        //     column: params.column.title,
        //     type: params.column.uidt,
        //   });
        // }
        if (value.length > _constants.NC_MAX_TEXT_LENGTH) {
            _catchError.NcError._.valueLengthExceedLimit({
                length: value.length,
                column: params.column.title,
                type: params.column.uidt,
                maxLength: _constants.NC_MAX_TEXT_LENGTH
            });
        }
        // we return a string all the time to support any input (number, boolean, etc.) on text fields
        return {
            value: (0, _nocodbsdk.isAIPromptCol)(params.column) ? params.value : value
        };
    }
};
